<template>
  <div class="wrapper">
    <span class="w-title">发票数量管理</span>
    <v-divider class="my-3"/>
    <v-container fluid grid-list-md class="xn-form pa-0">
      <v-layout wrap>
        <v-flex xs12 sm6 md3>
          <v-text-field
            v-model="filters.name"
            label="公司名称"
            outline
            solo
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3 style="display: flex;margin-bottom: 20px;">
          <v-btn color="info" style="margin-right: 5px !important;" @click="refresh">查询</v-btn>
          <v-btn color="info" @click="clearFilters">重置</v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <DataTable
      ref="dataTable"
      item-key="companyId"
      sort-by="companyId"
      :headers="headers"
      :fetch-data="refreshList"
      @editButtonClicked="editButtonClicked"
      @addButtonClicked="addButtonClicked"
    >
    </DataTable>

    <!--弹出层-编辑数量-->
    <v-dialog v-model="showEdit" max-width="500px">
      <v-card>
        <v-card-title>编辑发票数量</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid grid-list-md class="xn-form">
            <v-layout wrap>
              <v-flex xs4 class="d-flex mt-2 text-xs-right">
                <label>公司:</label>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  outline
                  solo
                  disabled
                  :value="item.name">
                </v-text-field>
              </v-flex>
              <v-flex xs4 class="d-flex mt-2 text-xs-right">
                <label>发票额度:</label>
              </v-flex>
              <v-flex xs8>
                <v-select
                  v-model="item.receiptMax"
                  label="发票额度"
                  :items="receiptMaxs"
                  outline
                  solo
                ></v-select>
              </v-flex>
              <v-flex xs4 class="d-flex mt-2 text-xs-right">
                <label class="required">核定普通发票数量:</label>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  ref="form.normalReceiptApproved"
                  v-model="item.normalReceiptApproved"
                  outline
                  solo
                  :rules="[rules.isNumber,rules.required]"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs4 class="d-flex mt-2 text-xs-right">
                <label class="required">核定专用发票数量:</label>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  ref="form.specialReceiptApproved"
                  v-model="item.specialReceiptApproved"
                  outline
                  solo
                  :rules="[rules.isNumber,rules.required]"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs4 class="d-flex mt-2 text-xs-right">
                <label class="required">剩余普通发票数量:</label>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  ref="form.normalReceiptRemaining"
                  v-model="item.normalReceiptRemaining"
                  outline
                  solo
                  :rules="[rules.isNumber,rules.required]"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs4 class="d-flex mt-2 text-xs-right">
                <label class="required">剩余专用发票数量:</label>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  ref="form.specialReceiptRemaining"
                  v-model="item.specialReceiptRemaining"
                  outline
                  solo
                  :rules="[rules.isNumber,rules.required]"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 offset-xs4>
                <v-btn flat outline style="margin-right: 10px !important;" @click="showEdit = false">
                  返回
                </v-btn>
                <v-btn color="info" @click="patchEditHandler">保存</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--弹出层-编辑数量-->

    <!--弹出层-增加数量-->
    <v-dialog v-model="showAdd" max-width="500px">
      <v-card>
        <v-card-title>增加发票数量</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid grid-list-md class="xn-form">
            <v-layout wrap>
              <v-flex xs4 class="d-flex mt-2 text-xs-right">
                <label>公司:</label>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  outline
                  solo
                  disabled
                  :value="item.name">
                </v-text-field>
              </v-flex>
              <v-flex xs4 class="d-flex mt-2 text-xs-right">
                <label>发票类型:</label>
              </v-flex>
              <v-flex xs8>
                <v-radio-group v-model="receiptType" row @change="typeChange">
                  <v-radio label="普通发票" value="普通发票"></v-radio>
                  <v-radio label="专用发票" value="专用发票"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex xs4 class="d-flex mt-2 text-xs-right">
                <label class="required">增加数量:</label>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  ref="form.addCount"
                  v-model="addCount"
                  outline
                  solo
                  :rules="[rules.isNumber,rules.required]"
                >
                </v-text-field>
              </v-flex>

              <v-flex xs12 offset-xs4>
                <v-btn flat outline style="margin-right: 10px !important;" @click="showAdd = false">
                  返回
                </v-btn>
                <v-btn color="info" @click="patchAddHandler">保存</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--弹出层-增加数量-->
  </div>
</template>

<script>
  /**
   * 发票余量
   */
  import axios from "../axios";
  import DataTable from "../components/DataTableReceiptCount";
  import {dateFormat} from "vue-filter-date-format";
  import {mapActions} from 'vuex';

  export default {
    components: {
      DataTable
    },
    computed: {},
    data: () => ({
      headers: [
        {text: '', value: '',sortable: false},
        {text: '公司名称', value: 'name'},
        {text: '发票额度', value: 'receiptMax'},
        {text: '核定普通发票数量', value: 'normalReceiptApproved'},
        {text: '核定专用发票数量', value: 'specialReceiptApproved'},
        {text: '剩余普通发票数量', value: 'normalReceiptRemaining'},
        {text: '剩余专用发票数量', value: 'specialReceiptRemaining'},
        {text: "操作", align: "center", value: "settings", sortable: false}
      ],
      receiptMaxs:[
        {value: "万元版", text: "万元版"},
        {value: "十万元版", text: "十万元版"},
        {value: "百万元版", text: "百万元版"},
        {value: "千万元版", text: "千万元版"},
      ],
      rules: {
        required: value => value !== '' || "必填",
        isNumber: value => {
          const pattern = /^\d+$/;
          return (typeof value === "undefined" || value === null || value === "" || pattern.test(value)) || "请输入正确的数量";
        },
      },
      filters: {},
      showEdit: false,
      showAdd: false,
      item: {},
      addCount:0,
      receiptType:'普通发票',
      hasErrors: false,
    }),
    methods: {
      ...mapActions(['setLoading']),
      refreshList(pagination, searchText, callback, failure) {

        axios
          .get("/companies", {
            params: {
              page: pagination.page - 1,
              size: pagination.rowsPerPage === -1 ? 2147483647 : pagination.rowsPerPage,
              sort:
                pagination.sortBy === null
                  ? null
                  : pagination.sortBy +
                  "," +
                  (pagination.descending ? "desc" : "asc"),
              companyId: this.$currentCompany ? this.$currentCompany.id : null,
              name:this.filters.name?`contains(${this.filters.name})`:null,
            }
          })
          .then(response => {
            callback(response.data.total, response.data.data);
          })
          .catch(reason => {
            if (failure) {
              failure(reason);
            }
          });
      },
      editButtonClicked(item) {
        this.showEdit = true;
        this.item = {...item};
      },
      typeChange() {
        //我也是醉了，这块竟然要用延迟才能更新
        if (this.receiptType === '普通发票') {
          this.addCount = this.item.normalReceiptApproved;
        } else if (this.receiptType === '专用发票') {
          this.addCount = this.item.specialReceiptApproved;
        }
      },
      validate() {
        this.hasErrors = false;
        Object.keys(this.item).forEach(f => {
          if (
            this.$refs["form." + f] !== null &&
            typeof this.$refs["form." + f] !== "undefined"
          ) {
            if (!this.$refs["form." + f].validate(true)) {
              this.hasErrors = true;
            }
          }
        });
      },
      patchEditHandler() {
        this.validate();
        if (!this.hasErrors) {
          this.setLoading(true);
          axios.patch("/companies/" + this.item.companyId, this.item)
            .then(() => {
              this.showEdit = false;
              this.setLoading(false);
              this.refresh();
            })
            .catch(reason => {
              this.$confirm(reason.response.data.message, {buttonFalseText: null});
              this.setLoading(false);
            });
        }
      },
      addButtonClicked(item) {
        this.showAdd = true;
        this.item = {...item};
        //this.item.receiptType = '普通发票';
        this.addCount = this.item.normalReceiptApproved;
      },
      patchAddHandler() {
        this.validate();
        if (!this.hasErrors) {
          this.setLoading(true);
          let obj = {};
          if (this.receiptType === '普通发票') {
            obj.normalReceiptRemaining = parseInt(this.item.normalReceiptRemaining) + parseInt(this.addCount);
          }
          if (this.receiptType === '专用发票') {
            obj.specialReceiptRemaining = parseInt(this.item.specialReceiptRemaining) + parseInt(this.addCount);
          }
          axios.patch("/companies/" + this.item.companyId, obj)
            .then(() => {
              this.showAdd = false;
              this.setLoading(false);
              this.refresh();
            })
            .catch(reason => {
              this.$confirm(reason.response.data.message, {buttonFalseText: null});
              this.setLoading(false);
            });
        }
      },
      refresh() {
        this.$refs.dataTable.refresh();
      },
      clearFilters() {
        this.filters = {};
        this.refresh();
      }
    }
  }
</script>

<style scoped>

</style>
